import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";

export const metadataFields = {
  created_at: {
    type: "date",
    label: "Created",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 2,
    filterType: "dateRange",
    width: 130,
    minWidth: 110,
    maxWidth: 160,
    icon: "Plus",
    allowedRoles: ["wtc_admin", "wtc_crm", "wtc_employee"],
    mobileDetailSectionId: "metadata",
  },
  updated_at: {
    type: "date",
    label: "Updated",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: false,
    formSpan: 2,
    filterType: "dateRange",
    width: 130,
    minWidth: 110,
    maxWidth: 160,
    icon: "Edit",
    allowedRoles: ["wtc_admin", "wtc_crm", "wtc_employee"],
    mobileDetailSectionId: "metadata",
  },
  // FK: offerings.created_by → app_users.id (production: offerings_created_by_fkey, ON DELETE SET NULL)
  created_by: {
    type: "text",
    label: "Created By",
    isForeignKey: true,
    foreignKey: {
      referencedTable: "app_users",
      referencedColumn: "id",
      constraintName: "offerings_created_by_fkey",
      onDelete: "SET NULL",
      onUpdate: "NO ACTION",
      relationKind: "many-to-one",
    },
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    width: 160,
    minWidth: 120,
    maxWidth: 220,
    icon: "User",
    allowedRoles: ["wtc_admin", "wtc_crm", "wtc_employee"],
    mobileDetailSectionId: "metadata",
  },
} satisfies Record<string, SimpleFieldConfig>;
